// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React, { useState, useEffect, useRef } from 'react';
import { useOutlet, history } from 'dumi';
import { warning } from '/home/runner/work/GPT-Vis/GPT-Vis/node_modules/.pnpm/rc-util@5.44.4_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/rc-util';
import { SiteContext, type ISiteContext } from '/home/runner/work/GPT-Vis/GPT-Vis/node_modules/.pnpm/dumi@2.4.21_@babel+core@7.28.0_@swc+helpers@0.5.1_@types+node@24.0.14_@types+react@18.3.23_@t_n3pfsrvzcbo6za7u5d6thsteeq/node_modules/dumi/dist/client/theme-api/context.js';
import { components } from '../meta/atoms';
import { locales } from '../locales/config';



const entryExports = {
};

// Static content
const pkg = {"name":"@antv/gpt-vis","description":"Components for GPTs, generative AI, and LLM projects. Not only UI Components.","version":"0.5.0","license":"MIT","repository":{"type":"git","url":"https://github.com/antvis/GPT-Vis"},"author":"antvis"};
const historyType = "browser";
const hostname = undefined;
const themeConfig = {"footer":"Open-source MIT Licensed | Copyright © 2024\n<br />\nPowered by <a herf=\"https://antv.antgroup.com\">AntV</a>","prefersColor":{"default":"light","switch":false},"nprogress":true,"lastUpdated":true,"name":"GPT-Vis","logo":"https://gw.alipayobjects.com/zos/antfincdn/FLrTNDvlna/antv.png","socialLinks":{"github":"https://github.com/antvis/GPT-Vis"},"sourceLink":"https://github.com/antvis/GPT-Vis/tree/HEAD/{fileName}#L{line}","editLink":"https://github.com/antvis/GPT-Vis/edit/HEAD/{filename}"};
const _2_level_nav_available = true;

export default function DumiContextWrapper() {
  const outlet = useOutlet();
  const [loading, setLoading] = useState(false);
  const prev = useRef(history.location.pathname);

  useEffect(() => {
    return history.listen((next) => {
      if (next.location.pathname !== prev.current) {
        prev.current = next.location.pathname;

        // scroll to top when route changed
        document.documentElement.scrollTo(0, 0);
      }
    });
  }, []);

  const context: ISiteContext = React.useMemo(() => {
    const ctx = {
      pkg,
      historyType,
      entryExports,
      demos: null,
      components,
      locales,
      loading,
      setLoading,
      hostname,
      themeConfig,
      _2_level_nav_available,
    };

    // Proxy do not warning since `Object.keys` will get nothing to loop
    Object.defineProperty(ctx, 'demos', {
      get: () => {
        warning(false, '`demos` return empty in latest version, please use `useDemo` instead.');
        return {};
      },
    });

    return ctx;
  }, [
    pkg,
    historyType,
    entryExports,
    components,
    locales,
    loading,
    setLoading,
    hostname,
    themeConfig,
    _2_level_nav_available,
  ]);

  return (
    <SiteContext.Provider value={context}>
      {outlet}
    </SiteContext.Provider>
  );
}
